module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-create-entity-button"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Name"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localValue.name),
      expression: "localValue.name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.localValue.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localValue, "name", $event.target.value)
      }
    }
  })]), _c('label', [_vm._v("Description"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localValue.description),
      expression: "localValue.description"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.localValue.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localValue, "description", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', [_c('label', [_vm._v("Number required")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localValue.has_number),
      expression: "localValue.has_number"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.localValue.has_number) ? _vm._i(_vm.localValue.has_number, null) > -1 : (_vm.localValue.has_number)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.localValue.has_number,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.localValue, "has_number", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.localValue, "has_number", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.localValue, "has_number", $$c)
        }
      }
    }
  })]), _c('div', [_c('label', [_vm._v("Emission date required")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localValue.has_emission),
      expression: "localValue.has_emission"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.localValue.has_emission) ? _vm._i(_vm.localValue.has_emission, null) > -1 : (_vm.localValue.has_emission)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.localValue.has_emission,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.localValue, "has_emission", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.localValue, "has_emission", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.localValue, "has_emission", $$c)
        }
      }
    }
  })]), _c('div', [_c('label', [_vm._v("Expiry date required")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localValue.has_expiry),
      expression: "localValue.has_expiry"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.localValue.has_expiry) ? _vm._i(_vm.localValue.has_expiry, null) > -1 : (_vm.localValue.has_expiry)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.localValue.has_expiry,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.localValue, "has_expiry", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.localValue, "has_expiry", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.localValue, "has_expiry", $$c)
        }
      }
    }
  })])]), _c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Issuer required")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localValue.has_issuer),
      expression: "localValue.has_issuer"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.localValue.has_issuer) ? _vm._i(_vm.localValue.has_issuer, null) > -1 : (_vm.localValue.has_issuer)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.localValue.has_issuer,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.localValue, "has_issuer", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.localValue, "has_issuer", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.localValue, "has_issuer", $$c)
        }
      }
    }
  }), _c('div', [_c('label', [_vm._v("Country required")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localValue.has_country),
      expression: "localValue.has_country"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.localValue.has_country) ? _vm._i(_vm.localValue.has_country, null) > -1 : (_vm.localValue.has_country)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.localValue.has_country,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.localValue, "has_country", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.localValue, "has_country", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.localValue, "has_country", $$c)
        }
      }
    }
  })])])]), _c('label', [_vm._v("Attachment views"), _vm._l((_vm.localValue.attachment_views), function(attachments, index) {
    return (typeof _vm.localValue.attachment_views !== 'string') ? _c('div', {
      staticClass: "input-group"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.localValue.attachment_views[index]),
        expression: "localValue.attachment_views[index]"
      }],
      staticClass: "input-group-field",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.localValue.attachment_views[index])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.localValue.attachment_views, index, $event.target.value)
        }
      }
    }), _c('div', {
      staticClass: "input-group-button"
    }, [_c('button', {
      staticClass: "button warning",
      on: {
        "click": function($event) {
          return _vm.localValue.attachment_views.splice(index, 1)
        }
      }
    }, [_vm._v("-")])])]) : _vm._e()
  })], 2), _c('button', {
    staticClass: "button small",
    on: {
      "click": function($event) {
        return _vm.localValue.attachment_views.push([])
      }
    }
  }, [_vm._v("Add view")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2893314c!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/forms/DocumentTypeForm.vue
// module id = 2342
// module chunks = 1